import { defineMobileWindow } from "@app/overlay";
import { WsLeaveCardContent, type WsLeaveCardContentProps } from "./components/LeaveContent/WsLeaveCardContent";

/** Реестр overlay-окон карточки лимитной карты. */
export const wsLimitCardWindows = {
    leave: defineMobileWindow<WsLeaveCardContentProps>({
        key: "workshop.limitCard.leave",
        title: ({ limitCard }) => `Отпуск ЛК №${limitCard.Num}`,
        component: WsLeaveCardContent,
    }),
};
